/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Notify/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaPendingTag from 'DesignSystem/TysiaPendingTag/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2UserAlertBellIcon from 'DesignSystem/Svgs/Tysiav2UserAlertBellIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Notify({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/AdditionalOptions/Content/Options/Notify"
  
}) {
let appointmentOverlayNotifyValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'notify',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsBrandGreen = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.brand.green'
        })
let appointmentOverlayNotifyValueData1 = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'notify',
})
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let appointmentOverlayNotifyValueData2 = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'notify',
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="Notify.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Z2jfFuU': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-2-Z2jfFuU': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-3-Z2jfFuU': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-4-Z2jfFuU': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--btlr-5-Z2jfFuU': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--btrr-6-Z2jfFuU': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bbrr-7-Z2jfFuU': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bblr-8-Z2jfFuU': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--g-11-Z2jfFuU': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-9-Z2jfFuU': appointmentOverlayNotifyValueData ? dtColorsBrandGreen : dtColorsWhite,'--bc-10-Z2jfFuU': appointmentOverlayNotifyValueData ? dtColorsBrandGreen : dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2UserAlertBellIcon
  viewPath={`${viewPath}/Tysiav2UserAlertBellIcon`}
 fill2={appointmentOverlayNotifyValueData1 ? dtColorsWhite : dtColorsNeutral300}
 data="appointment_overlay.notify"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 weight="medium"
 color={appointmentOverlayNotifyValueData2 ? dtColorsWhite : dtColorsNeutral500}
 text="Patient will be notified"
 data="appointment_overlay.notify"
/>
<TysiaPendingTag
  viewPath={`${viewPath}/TysiaPendingTag`}
/>
</div>
{children}
</React.Fragment>)
}